import { DownloadType } from '../../../dto/enum/download-type.enum';
import { Injectable } from '@angular/core';
import { AbstractMediaFormProvider } from './abstract-media-form.provider';

@Injectable({
  providedIn: 'root',
})
export class VideoFormProvider extends AbstractMediaFormProvider {
  public getErrorTip = (): string =>
    $localize`:@@download-form-video-input-error-tip:Please, enter correct Instagram video link`;
  public getPlaceholder = (): string =>
    $localize`:@@download-form-video-input-placeholder:Instagram video link`;
  public getType = (): DownloadType => DownloadType.VIDEO;
}
